export const RISK_OF_FLOODING_CATEGORIES = [
  "high_risk_of_flooding_from_rivers_and_seas",
  "medium_risk_of_flooding_from_rivers_and_seas",
  "low_risk_of_flooding_from_rivers_and_seas",
  "very_low_risk_of_flooding_from_rivers_and_seas",
];

export const FLOOD_ZONE_CATEGORIES = [
  "flood_zone_3_env_agency",
  "flood_zone_2_env_agency",

  // TODO remove the categories below once the category hierarchy has been
  // update to remove the link to them from `flood_zones_outer`.
  "flood_zone_3b",
  "flood_zone_3a",
  "flood_zone_2",
];

export const SURFACE_FLOOD_CATEGORIES = [
  "high_risk_of_flooding_from_surface_water",
  "medium_risk_of_flooding_from_surface_water",
  "low_risk_of_flooding_from_surface_water",
];

export const SURFACE_FLOOD_CLIMATE_CATEGORIES = [
  "high_rofsw_climate_change",
  "medium_rofsw_climate_change",
  "low_rofsw_climate_change",
];
